class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code?.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }

    let cancelBtn = this.querySelector('.js-modal-cancel-btn');
    if(cancelBtn){
      cancelBtn.addEventListener('click', () => this.hide() );
    }
    if(this.hasAttribute('data-wishlist-popup')){
      this.wishlistAction();
    }
  }

  wishlistAction(){
    let isCustomerActive = this.hasAttribute('is-customer-active');
    let notifymeCheckbox = this.querySelector('.js-notify-me-checkbox');
    let emailInput = this.querySelector('.js-email-input');
    let emailValidation = () => {
      let isvalid = false;
      if(isCustomerActive == false){
        let emalErrorElement = this.querySelector('.js-mail-error');
        if(emailInput.value == ""){
          emalErrorElement.innerHTML = "Please enter your email address.";
          emalErrorElement.classList.remove('hidden');
          isvalid = false;
        }else{
          const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          isvalid = re.test(String(emailInput.value).toLowerCase());
          if(!isvalid){
            emalErrorElement.innerHTML = "Please enter valid email address.";
            emalErrorElement.classList.remove('hidden');
          }else{
            emalErrorElement.classList.add('hidden');
          }
        }
      }else{
        isvalid = true;
      }
      return isvalid;
    }
    if(!isCustomerActive){
      emailInput.addEventListener('input',() => {
        emailValidation();
      });
    }
    let wishlistButton = this.querySelector('.js-wishlist-submit-btn');
    wishlistButton.addEventListener('click',() => {
      if(emailValidation() == false){
        return;
      }
      wishlistButton.classList.add('loading');
      wishlistButton.querySelector('.js-spinner').classList.remove('hidden');
      let variantSelects = this.querySelector('variant-selects');
      let productdata = JSON.parse(this.querySelector('.product-json').innerHTML);
      document.dispatchEvent(new CustomEvent('wishlist:add',{
        detail: {
          element: this,
          wishlistButton :wishlistButton,
          variant: variantSelects ? variantSelects.currentVariant : null,
          email: emailInput.value,
          notifyme: (notifymeCheckbox) ? notifymeCheckbox.checked : false,
          product: productdata
        },
      }));
    })
  }

  connectedCallback() {
    if(document.querySelectorAll('#'+this.id).length > 1){
      this.remove();
    }
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
    /*if(this.id.includes('wishlist-popup-')){
      document.dispatchEvent(new CustomEvent('quickview:loaded',{
        detail: {
          currentElement: `#${this.id}`
        },
      }));
    }*/
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);